module.exports = __webpack_public_path__ + "static/media/trend-down.41fb7756.svg";